module.exports = __webpack_public_path__ + "static/sport/icon-1.d36021c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport6/icon-1.png
// module id = uKGT
// module chunks = 0